import { PriceTableDto } from '@tiendanube/common';

export enum statusType {
  idle = 'idle',
  loading = 'loading',
  error = 'error',
  success = 'success',
}

export interface PriceTablesInterface {
  priceTables: {
    status: statusType;
    data: PriceTableDto[];
  };
}
